/* LoveEcru snippet runtime. Explicit asset delivery restores the snippet behavior when Shopify serves an empty compiled bundle. */

// Source: snippets/le-nav-behavior.liquid
(() => {
  const modules = window.leSnippetRuntimeModules || (window.leSnippetRuntimeModules = new Set());
  if (modules.has("le-nav-behavior")) return;
  modules.add("le-nav-behavior");
  try {
if (!customElements.get('le-nav-behavior')) {
    customElements.define('le-nav-behavior', class extends HTMLElement {
      connectedCallback() {
        this.cleanup();
        this.header = this.closest('.le-nav-header[data-header-wrapper]');
        if (!this.header || this.header.classList.contains('js__header__clone')) return;
        this.drawer = this.header.querySelector('[data-drawer="hamburger"]');
        this.menus = [...this.header.querySelectorAll('[data-le-mega]')];
        this.groups = [...this.header.querySelectorAll('[data-le-mobile-group], [data-le-nav-subgroup]')];
        this.cart = document.querySelector('[data-drawer="drawer-cart"]');
        this.search = document.getElementById('search-popdown');
        this.nativeSearchTrigger = this.header.querySelector('[data-popdown-toggle="search-popdown"]');
        this.localization = this.header.querySelector('.le-nav-localization');
        this.desktop = window.matchMedia('(min-width: 990px)');
        this.hover = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.controller = new AbortController();
        this.timers = new Map();
        this.hoverOpened = new WeakSet();
        this.keyboard = false;
        this.wasDrawerOpen = false;
        this.swallowEscape = false;
        const options = { signal: this.controller.signal };
        const capture = { ...options, capture: true };
        const listen = (target, name, callback, settings = options) => target?.addEventListener(name, callback, settings);

        this.menus.forEach(menu => {
          listen(menu, 'pointerenter', event => {
            if (!this.desktop.matches || !this.hover.matches || event.pointerType === 'touch') return;
            this.schedule(menu, () => this.openMenu(menu, true), 130);
          });
          listen(menu, 'pointerleave', event => {
            if (!this.hover.matches || event.pointerType === 'touch') return;
            this.schedule(menu, () => {
              if (!this.keyboard || !menu.contains(document.activeElement)) this.setExpanded(menu, false);
            }, 220);
          });
          listen(menu, 'focusin', () => this.cancelTimer(menu));
          listen(menu, 'focusout', event => {
            if (!menu.contains(event.relatedTarget)) this.setExpanded(menu, false);
          });
          listen(this.summary(menu), 'click', event => {
            this.cancelTimer(menu);
            if (menu.open && this.hoverOpened.has(menu) && event.detail > 0) event.preventDefault();
            this.hoverOpened.delete(menu);
          });
        });

        listen(this.header, 'toggle', event => {
          const details = event.target;
          if (!this.menus.includes(details) && !this.groups.includes(details)) return;
          this.syncExpanded(details);
          if (!details.open) return;
          if (this.menus.includes(details)) {
            this.menus.forEach(menu => { if (menu !== details) this.setExpanded(menu, false); });
          } else {
            const parent = details.parentElement.closest('[data-le-mobile-group], [data-le-nav-subgroup]');
            this.groups.forEach(group => {
              if (group !== details && group.parentElement.closest('[data-le-mobile-group], [data-le-nav-subgroup]') === parent) {
                this.setExpanded(group, false);
              }
            });
          }
        }, capture);

        listen(document, 'pointerdown', event => {
          this.keyboard = false;
          if (!this.menus.some(menu => menu.contains(event.target))) this.closeMenus();
        }, capture);
        listen(document, 'click', event => {
          if (!this.menus.some(menu => menu.contains(event.target))) this.closeMenus();
          const toggle = event.target.closest('[data-drawer-toggle="hamburger"]');
          if (toggle && this.header.contains(toggle) && !this.drawer?.contains(toggle)) this.drawerTrigger = toggle;
          if (event.target.closest('[data-drawer-toggle], [data-popdown-toggle]')) this.closeMenus();
          const searchTrigger = event.target.closest('[data-popdown-toggle="search-popdown"]');
          if (searchTrigger && this.header.contains(searchTrigger)) {
            if (!this.forwardingSearch) this.searchTrigger = searchTrigger;
            if (searchTrigger !== this.nativeSearchTrigger && this.nativeSearchTrigger && this.search) {
              event.preventDefault();
              event.stopImmediatePropagation();
              this.forwardingSearch = true;
              this.nativeSearchTrigger.click();
              this.forwardingSearch = false;
            }
          }
        }, capture);
        listen(document, 'keydown', event => this.onKeydown(event), capture);
        listen(document, 'keyup', event => {
          if ((event.key === 'Escape' || event.code === 'Escape') && this.swallowEscape) {
            this.swallowEscape = false;
            event.preventDefault();
            event.stopImmediatePropagation();
          }
          const searchTrigger = event.target.closest('[data-popdown-toggle="search-popdown"]');
          if ((event.key === ' ' || event.code === 'Space') && searchTrigger && this.header.contains(searchTrigger) && searchTrigger !== this.nativeSearchTrigger) {
            event.preventDefault();
            event.stopImmediatePropagation();
            searchTrigger.click();
          }
        }, capture);
        listen(window, 'blur', () => { this.swallowEscape = false; this.closeMenus(); this.closeLocalization(); });

        if (this.drawer) {
          this.drawerObserver = new MutationObserver(() => this.syncDrawer());
          this.drawerObserver.observe(this.drawer, { attributes: true, attributeFilter: ['class'] });
          listen(this.drawer, 'theme:drawer:open', () => this.closeMenus(), capture);
          this.syncDrawer();
        }
        this.countObserver = new MutationObserver(records => records.forEach(record => this.syncCount(record.target)));
        this.countObserver.observe(this.header, { subtree: true, attributes: true, attributeFilter: ['data-header-cart-count'] });
        this.header.querySelectorAll('[data-header-cart-count]').forEach(element => this.syncCount(element));
        this.overlayObserver = new MutationObserver(() => this.syncOverlays());
        [this.cart, this.search].filter(Boolean).forEach(element => {
          this.overlayObserver.observe(element, { attributes: true, attributeFilter: ['class'] });
          listen(element, 'theme:drawer:open', () => this.closeMenus(), capture);
        });
        this.syncOverlays();
        [...this.menus, ...this.groups].forEach(details => {
          const summary = this.summary(details);
          const panel = details.querySelector(':scope > div');
          if (summary && panel) {
            if (!panel.id) {
              let panelId;
              do {
                this.constructor.nextPanelId = (this.constructor.nextPanelId || 0) + 1;
                panelId = `le-nav-disclosure-${this.constructor.nextPanelId}`;
              } while (document.getElementById(panelId));
              panel.id = panelId;
            }
            summary.setAttribute('aria-controls', panel.id);
            if (summary.tabIndex < 0) summary.tabIndex = 0;
          }
          this.syncExpanded(details);
        });

        const headerBar = this.header.querySelector('.theme__header');
        this.measure = () => {
          this.measureFrame = 0;
          if (!headerBar || !this.isConnected) return;
          const rect = headerBar.getBoundingClientRect();
          const backfill = this.header.nextElementSibling;
          if (rect.height > 0 && backfill?.matches('[data-header-backfill]')) {
            backfill.style.setProperty('--le-header-space', `${rect.height}px`);
          }
          const viewportBottom = window.visualViewport ? window.visualViewport.height + window.visualViewport.offsetTop : window.innerHeight;
          this.header.style.setProperty('--le-nav-available-height', `${Math.max(0, viewportBottom - Math.max(0, rect.bottom) - 16)}px`);
        };
        const queueMeasure = () => { if (!this.measureFrame) this.measureFrame = requestAnimationFrame(this.measure); };
        if (headerBar && 'ResizeObserver' in window) {
          this.heightObserver = new ResizeObserver(queueMeasure);
          this.heightObserver.observe(headerBar);
        }
        listen(window, 'resize', queueMeasure, { ...options, passive: true });
        listen(window, 'scroll', queueMeasure, { ...options, passive: true });
        listen(window.visualViewport, 'resize', queueMeasure, { ...options, passive: true });
        listen(window.visualViewport, 'scroll', queueMeasure, { ...options, passive: true });
        listen(this.desktop, 'change', () => {
          const focusedMenu = this.menus.some(menu => menu.contains(document.activeElement));
          this.closeMenus();
          this.closeLocalization();
          if (this.desktop.matches && this.drawerIsOpen()) {
            const restoreFocus = this.drawer.contains(document.activeElement);
            this.suppressDrawerRestore = true;
            this.drawer.dispatchEvent(new CustomEvent('theme:drawer:close'));
            if (restoreFocus) this.summary(this.menus[0])?.focus({ preventScroll: true });
          } else if (!this.desktop.matches && focusedMenu) {
            this.visibleDrawerTrigger()?.focus({ preventScroll: true });
          }
          queueMeasure();
        });
        listen(this.hover, 'change', () => this.closeMenus());
        listen(document, 'shopify:section:unload', event => {
          if (event.target.contains(this)) this.cleanup(true);
        });
        this.measure();
      }

      summary(details) {
        return details?.querySelector(':scope > summary');
      }

      syncExpanded(details) {
        this.summary(details)?.setAttribute('aria-expanded', String(details.open));
      }

      setExpanded(details, open) {
        this.cancelTimer(details);
        if (!open) this.hoverOpened?.delete(details);
        details.open = open;
        this.syncExpanded(details);
        if (!open) details.querySelectorAll('[data-le-nav-subgroup][open]').forEach(child => {
          child.open = false;
          this.syncExpanded(child);
        });
      }

      openMenu(menu, fromHover = false) {
        if (!this.desktop.matches || this.drawerIsOpen() || this.otherOverlayIsOpen()) return;
        this.closeLocalization();
        const wasOpen = menu.open;
        this.menus.forEach(other => this.setExpanded(other, other === menu));
        if (fromHover && !wasOpen) this.hoverOpened.add(menu);
        else if (!fromHover) this.hoverOpened.delete(menu);
      }

      closeMenus() {
        this.menus?.forEach(menu => this.setExpanded(menu, false));
      }

      closeLocalization() {
        this.localization?.querySelectorAll('[data-popout-toggle][aria-expanded="true"]').forEach(toggle => toggle.click());
      }

      cancelTimer(menu) {
        clearTimeout(this.timers?.get(menu));
        this.timers?.delete(menu);
      }

      schedule(menu, callback, delay) {
        this.cancelTimer(menu);
        this.timers.set(menu, setTimeout(() => { this.timers.delete(menu); callback(); }, delay));
      }

      visible(element) {
        if (!element || element.closest('[hidden], [inert], [aria-hidden="true"]') || !element.getClientRects().length) return false;
        const style = getComputedStyle(element);
        if (style.visibility === 'hidden' || style.visibility === 'collapse' || style.display === 'none') return false;
        for (let ancestor = element.parentElement; ancestor; ancestor = ancestor.parentElement) {
          if (ancestor.tagName === 'DETAILS' && !ancestor.open && !this.summary(ancestor)?.contains(element)) return false;
        }
        return true;
      }

      focusable(container) {
        return [...container.querySelectorAll('a[href], button, input:not([type="hidden"]), select, textarea, summary, [tabindex]')]
          .filter(element => element.tabIndex >= 0 && !element.matches(':disabled') && this.visible(element));
      }

      drawerIsOpen() {
        return Boolean(this.drawer?.classList.contains('drawer--visible'));
      }

      otherOverlayIsOpen() {
        return Boolean(this.cart?.matches('.drawer--visible, .is-open') || this.search?.classList.contains('is-visible'));
      }

      visibleDrawerTrigger() {
        if (this.drawerTrigger?.isConnected && this.visible(this.drawerTrigger)) return this.drawerTrigger;
        return [...this.header.querySelectorAll('[data-drawer-toggle="hamburger"]')]
          .find(button => !this.drawer?.contains(button) && this.visible(button));
      }

      syncDrawer() {
        const open = this.drawerIsOpen();
        this.header.querySelectorAll('[data-drawer-toggle="hamburger"]').forEach(button => {
          if (this.drawer.contains(button)) button.removeAttribute('aria-expanded');
          else {
            button.setAttribute('aria-expanded', String(open));
            button.setAttribute('aria-controls', this.drawer.id);
            button.setAttribute('aria-haspopup', 'dialog');
          }
        });
        this.drawer.setAttribute('aria-modal', String(open));
        if (open) this.closeMenus();
        if (open && !this.wasDrawerOpen) {
          this.drawerFocusFrame = requestAnimationFrame(() => {
            if (this.drawerIsOpen()) this.drawer.querySelector('[data-first-focus]')?.focus({ preventScroll: true });
          });
        }
        if (this.wasDrawerOpen && !open) {
          this.drawer.querySelectorAll('[data-popout-toggle][aria-expanded="true"]').forEach(toggle => toggle.click());
          this.groups.forEach(group => this.setExpanded(group, false));
          if (!this.suppressDrawerRestore && !this.otherOverlayIsOpen()) this.visibleDrawerTrigger()?.focus({ preventScroll: true });
          this.suppressDrawerRestore = false;
        }
        this.wasDrawerOpen = open;
      }

      syncCount(element) {
        element.textContent = element.getAttribute('data-header-cart-count');
      }

      syncOverlays() {
        if (this.otherOverlayIsOpen()) this.closeMenus();
        if (this.cart) this.header.querySelectorAll('[data-drawer-toggle="drawer-cart"]').forEach(button => {
          button.setAttribute('aria-expanded', String(this.cart.matches('.drawer--visible, .is-open')));
          if (this.cart.id) button.setAttribute('aria-controls', this.cart.id);
          button.setAttribute('aria-haspopup', 'dialog');
        });
        if (this.search) this.header.querySelectorAll('[data-popdown-toggle="search-popdown"]').forEach(button => {
          button.setAttribute('aria-expanded', String(this.search.classList.contains('is-visible')));
          button.setAttribute('aria-controls', this.search.id);
        });
        const searchOpen = Boolean(this.search?.classList.contains('is-visible'));
        if (this.wasSearchOpen && !searchOpen && !this.drawerIsOpen() && !this.otherOverlayIsOpen() && this.visible(this.searchTrigger)) {
          this.searchTrigger.focus({ preventScroll: true });
        }
        this.wasSearchOpen = searchOpen;
      }

      onKeydown(event) {
        this.keyboard = true;
        const searchTrigger = event.target.closest('[data-popdown-toggle="search-popdown"]');
        if ((event.key === ' ' || event.code === 'Space') && searchTrigger && this.header.contains(searchTrigger)) event.preventDefault();
        const escape = event.key === 'Escape' || event.code === 'Escape';
        if (this.swallowEscape && escape && event.repeat) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const selector = event.target.closest('.le-nav-localization popout-select');
        if (selector) {
          const toggle = selector.querySelector('[data-popout-toggle]');
          const options = [...selector.querySelectorAll('[data-popout-option]')];
          if (escape && toggle?.getAttribute('aria-expanded') === 'true') {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.swallowEscape = true;
            toggle.click();
            toggle.focus({ preventScroll: true });
            return;
          }
          if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (toggle?.getAttribute('aria-expanded') !== 'true') toggle?.click();
            const index = options.indexOf(event.target.closest('[data-popout-option]'));
            const next = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 : index < 0 ? (event.key === 'ArrowUp' ? options.length - 1 : 0) : (index + (event.key === 'ArrowUp' ? -1 : 1) + options.length) % options.length;
            options[next]?.focus();
            return;
          }
        }
        const mobileOpen = this.drawerIsOpen() && !this.otherOverlayIsOpen();
        if (mobileOpen && (event.key === 'Tab' || event.code === 'Tab')) {
          const elements = this.focusable(this.drawer);
          const index = elements.indexOf(document.activeElement);
          const next = index < 0 ? (event.shiftKey ? elements.length - 1 : 0) : (index + (event.shiftKey ? -1 : 1) + elements.length) % elements.length;
          event.preventDefault();
          event.stopImmediatePropagation();
          (elements[next] || this.drawer).focus({ preventScroll: false });
          return;
        }
        if (mobileOpen && escape && this.drawer.contains(event.target)) {
          const openSelector = this.drawer.querySelector('[data-popout-toggle][aria-expanded="true"]');
          if (openSelector) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.swallowEscape = true;
            openSelector.click();
            openSelector.focus({ preventScroll: true });
            return;
          }
          const group = event.target.closest('[data-le-mobile-group][open], [data-le-nav-subgroup][open]');
          if (group) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.swallowEscape = true;
            this.setExpanded(group, false);
            this.summary(group)?.focus({ preventScroll: true });
            return;
          }
        }
        const summary = event.target.closest('summary');
        const details = summary?.parentElement;
        if (event.key === 'ArrowDown' && (this.menus.includes(details) || this.groups.includes(details))) {
          event.preventDefault();
          event.stopPropagation();
          if (this.menus.includes(details)) this.openMenu(details);
          else this.setExpanded(details, true);
          if (details.open) this.focusable(details).find(element => element !== summary)?.focus();
          return;
        }
        if (escape) {
          const focusedMenu = this.menus.find(menu => menu.open && menu.contains(event.target));
          const anyOpen = this.menus.some(menu => menu.open);
          this.closeMenus();
          if (anyOpen) event.preventDefault();
          if (focusedMenu) this.summary(focusedMenu)?.focus({ preventScroll: true });
        }
      }

      cleanup(releaseScroll = false) {
        if (releaseScroll && this.drawerIsOpen() && !this.otherOverlayIsOpen()) {
          document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
        }
        this.controller?.abort();
        [this.drawerObserver, this.heightObserver, this.countObserver, this.overlayObserver].forEach(observer => observer?.disconnect());
        this.timers?.forEach(timer => clearTimeout(timer));
        this.timers?.clear();
        cancelAnimationFrame(this.measureFrame);
        cancelAnimationFrame(this.drawerFocusFrame);
        this.measureFrame = 0;
      }

      disconnectedCallback() {
        this.cleanup(true);
      }
    });
  }
  } catch (error) {
    modules.delete("le-nav-behavior");
    console.error('LoveEcru snippet initialization failed:', "le-nav-behavior", error);
  }
})();

// Source: snippets/le-gift-amount.liquid
(() => {
  const modules = window.leSnippetRuntimeModules || (window.leSnippetRuntimeModules = new Set());
  if (modules.has("le-gift-amount")) return;
  modules.add("le-gift-amount");
  try {
if (!customElements.get('le-gift-amount')) {
    customElements.define('le-gift-amount', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.format();
        this.contentObserver = new MutationObserver(() => this.format());
        this.contentObserver.observe(this, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['data-usd', 'data-eur', 'data-currency', 'data-base-currency'] });
        window.addEventListener('load', () => this.format(), { signal: this.controller.signal });
        document.addEventListener('le:currency-change', () => this.format(), { signal: this.controller.signal });
      }
      format() {
        const active = this.dataset.currency;
        const context = window.Shopify?.currency;
        const rate = Number(context?.rate);
        let currency = 'USD';
        let raw = Number(this.dataset.usd);
        if (active === 'EUR') {
          currency = 'EUR';
          raw = Number(this.dataset.eur);
        } else if (active !== 'USD' && this.dataset.baseCurrency === 'USD' && context?.active === active && Number.isFinite(rate) && rate > 0) {
          currency = active;
          raw *= rate;
        }
        if (!Number.isFinite(raw) || raw < 0) return;
        const amount = Number(raw.toFixed(2));
        try {
          const locale = document.documentElement.lang || undefined;
          const options = { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 2 };
          const text = new Intl.NumberFormat(locale, options).format(amount);
          const formatted = currency === 'USD' && active !== 'USD' ? `USD ${amount}` : text;
          if (this.textContent !== formatted) this.textContent = formatted;
          this.setAttribute('aria-label', new Intl.NumberFormat(locale, { ...options, currencyDisplay: 'code' }).format(amount));
          this.dataset.amount = String(amount);
          this.dataset.rawAmount = String(raw);
          this.dataset.formattedCurrency = currency;
        } catch (_) {
          const fallback = `${currency} ${amount}`;
          if (this.textContent !== fallback) this.textContent = fallback;
        }
      }
      disconnectedCallback() { this.controller?.abort(); this.contentObserver?.disconnect(); }
    });
  }
  } catch (error) {
    modules.delete("le-gift-amount");
    console.error('LoveEcru snippet initialization failed:', "le-gift-amount", error);
  }
})();

// Source: snippets/le-tessera-pair-behavior.liquid
(() => {
  const modules = window.leSnippetRuntimeModules || (window.leSnippetRuntimeModules = new Set());
  if (modules.has("le-tessera-pair-behavior")) return;
  modules.add("le-tessera-pair-behavior");
  try {
(() => {
  const copyElement = document.getElementById('le-pair-copy');
  if (!copyElement || window.leTesseraPairsReady) return;
  window.leTesseraPairsReady = true;
  const copy = JSON.parse(copyElement.textContent);
  const owner = 'tessera-pair';
  let pendingIntent = null;
  let recoveryPending = false;
  const validCart = cart => cart && Array.isArray(cart.items) && Number.isFinite(cart.total_price);
  const state = busy => {
    window.leTesseraPairBusy = busy;
    document.querySelectorAll('[data-le-xs-add], [data-le-xs-swap], [data-le-xs-select]').forEach(button => { button.disabled = busy; });
    document.dispatchEvent(new CustomEvent('le:pair:state'));
  };
  const feedback = (root, message, recovery = false) => {
    const node = root.querySelector('[data-le-xs-feedback]');
    if (node) { node.textContent = message; node.hidden = false; }
    const link = root.querySelector('[data-le-xs-recovery]');
    if (link) link.hidden = !recovery;
  };
  const hideOwned = cart => {
    const owned = new Set(cart.items.map(item => String(item.product_id)));
    const hasSet = cart.items.some(item => item.handle === 'tessera-serving-set');
    document.querySelectorAll('[data-le-xs-pdp] [data-le-xs-row]').forEach(row => {
      const isOwned = owned.has(row.dataset.productId) || (hasSet && row.dataset.pairHandle === 'tessera-hand-painted-mosaic-pitcher');
      row.dataset.owned = String(isOwned);
      row.hidden = isOwned || row.dataset.variantUnavailable === 'true';
    });
  };
  const complete = async (cart, root, detail) => {
    hideOwned(cart);
    const actual = await window.leTesseraRefreshCart(cart, true);
    feedback(root, copy.added);
    document.dispatchEvent(new CustomEvent('le:pair:complete', { detail: { ...detail, cart: actual, message: copy.added } }));
  };
  const mutate = async (button, row, root) => {
    const bridge = window.leCartBridge;
    if (!bridge) { feedback(root, copy.error); return; }
    if (window.leTesseraPairBusy || document.querySelector('.cart--loading, form[aria-busy="true"]') || !bridge.acquire(owner)) { feedback(root, document.querySelector('#drawer-cart')?.dataset.leLoading || copy.working); return; }
    const data = { ...row.dataset };
    const id = Number(data.variantId);
    const price = Number(data.price);
    const isSwap = button.hasAttribute('data-le-xs-swap');
    state(true);
    feedback(root, copy.working);
    pendingIntent = null;
    let finished = false;
    try {
      const before = await bridge.read();
      const productResponse = await bridge.request(`${data.productUrl}.js`, { cache: 'no-store' });
      if (!productResponse.ok) throw new Error(copy.error);
      const product = await productResponse.json();
      const variant = product.variants?.find(value => value.id === id);
      if (!variant?.available || variant.price !== price || before.items.some(item => item.product_id === product.id)) throw new Error(copy.changed);
      if (product.handle === 'tessera-hand-painted-mosaic-pitcher' && before.items.some(item => item.handle === 'tessera-serving-set')) throw new Error(copy.changed);
      let payload = { items: [{ id, quantity: 1 }] };
      if (isSwap) {
        const old = before.items.find(item => item.key === data.lineKey);
        const glasses = before.items.filter(item => ['tessera-hand-painted-mosaic-glass', 'tessera-noir-hand-painted-mosaic-glass'].includes(item.handle));
        if (!old || old.variant_id !== Number(data.oldVariant) || old.quantity !== 1 || old.final_line_price !== Number(data.oldPrice) || glasses.length !== 1 || before.items.some(item => ['tessera-hand-painted-mosaic-pitcher', 'tessera-serving-set'].includes(item.handle)) || old.selling_plan_allocation || Object.keys(old.properties || {}).length || old.final_line_price !== old.original_line_price || before.cart_level_discount_applications?.length) throw new Error(copy.changed);
        payload = { updates: { [old.key]: 0, [String(id)]: 1 } };
      }
      pendingIntent = { before, id, payload, oldKey: isSwap ? data.lineKey : null, productId: product.id };
      const actual = await bridge.transact(pendingIntent);
      await complete(actual, root, { productId: product.id, variantId: id });
      finished = true;
    } catch (error) {
      const uncertain = pendingIntent?.started && !pendingIntent.rejected;
      feedback(root, uncertain ? copy.uncertain : error.message || copy.error, Boolean(uncertain));
      document.dispatchEvent(new CustomEvent('le:pair:error', { detail: { message: uncertain ? copy.uncertain : error.message || copy.error, uncertain: Boolean(uncertain) } }));
      finished = !uncertain;
    } finally {
      if (finished) { pendingIntent = null; bridge.release(owner); state(false); }
    }
  };
  const recover = async root => {
    if (recoveryPending || !window.leCartBridge) return;
    recoveryPending = true;
    feedback(root, copy.working, true);
    try {
      const bridge = window.leCartBridge;
      const cart = await window.leTesseraRefreshCart(null, true);
      const added = pendingIntent && bridge.resolved(pendingIntent, cart);
      if (added) document.dispatchEvent(new CustomEvent('le:pair:complete', { detail: { cart, productId: pendingIntent.productId, variantId: pendingIntent.id, message: copy.added } }));
      feedback(root, added ? copy.added : copy.changed);
      pendingIntent = null;
      bridge.release(owner);
      state(false);
    } catch (_) { feedback(root, copy.uncertain, true); }
    finally { recoveryPending = false; }
  };
  document.addEventListener('click', event => {
    const recovery = event.target.closest('[data-le-xs-recovery]');
    if (recovery) { event.preventDefault(); recover(recovery.closest('.le-xs')); return; }
    if (window.leTesseraPairBusy && event.target.closest('[data-decrease-quantity], [data-increase-quantity], [data-remove-key], [name="checkout"], [data-le-atc], [data-le-sticky-atc], .rebuy-button')) {
      event.preventDefault(); event.stopImmediatePropagation(); return;
    }
    const button = event.target.closest('[data-le-xs-add], [data-le-xs-swap]');
    if (!button) return;
    event.preventDefault();
    const row = button.closest('[data-le-xs-upgrade], [data-le-xs-row]');
    const root = button.closest('.le-xs');
    if (row && root) mutate(button, row, root);
  }, true);
  document.addEventListener('submit', event => {
    if (window.leTesseraPairBusy && event.target.matches('form[action*="/cart"]')) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('change', event => {
    if (window.leTesseraPairBusy && event.target.matches('[data-quantity-input]')) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('theme:cart:change', event => { if (validCart(event.detail?.cart)) hideOwned(event.detail.cart); });
  document.addEventListener('le:variant:change', event => {
    if (event.detail?.handle !== 'tessera-serving-set') return;
    const root = document.querySelector('[data-le-xs-pdp][data-main-handle="tessera-serving-set"]');
    const data = root?.querySelector('[data-le-xs-set-map]');
    const row = root?.querySelector('[data-pair-handle="tessera-hand-painted-mosaic-glass"]');
    if (!data || !row) return;
    const map = JSON.parse(data.textContent);
    const pair = map[String(event.detail.id)];
    if (!pair) { row.dataset.variantUnavailable = 'true'; row.hidden = true; return; }
    row.dataset.variantUnavailable = 'false';
    row.hidden = row.dataset.owned === 'true';
    row.dataset.variantId = pair.id;
    row.dataset.price = pair.price;
    row.querySelector('.le-xs-price').textContent = pair.priceLabel;
    row.querySelector('.le-xs-variant').textContent = pair.title;
    const image = row.querySelector('.le-xs-image img');
    if (image && pair.image) { image.src = pair.image; image.removeAttribute('srcset'); }
    row.querySelectorAll('a').forEach(link => { link.href = `${row.dataset.productUrl}?variant=${pair.id}`; });
  });
})();
  } catch (error) {
    modules.delete("le-tessera-pair-behavior");
    console.error('LoveEcru snippet initialization failed:', "le-tessera-pair-behavior", error);
  }
})();

// Source: snippets/le-tessera-cart-carousel.liquid
(() => {
  const modules = window.leSnippetRuntimeModules || (window.leSnippetRuntimeModules = new Set());
  if (modules.has("le-tessera-cart-carousel")) return;
  modules.add("le-tessera-cart-carousel");
  try {
(() => {
  if (window.leTesseraCarouselReady) return;
  window.leTesseraCarouselReady = true;
  const positions = new WeakMap();
  const resizeObservers = new WeakMap();
  const bind = root => {
    if (root.dataset.carouselReady) return;
    root.dataset.carouselReady = 'true';
    const track = root.querySelector('[data-le-xs-track]');
    if (!track) return;
    const slides = [...track.querySelectorAll('[data-le-xs-slide]')];
    const previous = root.querySelector('[data-le-xs-prev]');
    const next = root.querySelector('[data-le-xs-next]');
    const counter = root.querySelector('[data-le-xs-counter]');
    const closestIndex = () => {
      const edge = track.getBoundingClientRect().left;
      return slides.reduce((best, slide, index) => Math.abs(slide.getBoundingClientRect().left - edge) < Math.abs(slides[best].getBoundingClientRect().left - edge) ? index : best, 0);
    };
    const update = () => {
      const index = closestIndex();
      positions.set(root.closest('#drawer-cart') || root, index);
      if (previous) previous.disabled = index === 0;
      if (next) next.disabled = index >= slides.length - 1;
      if (counter) {
        const value = `${index + 1} / ${slides.length}`;
        if (counter.textContent !== value) counter.textContent = value;
      }
    };
    const go = (index, smooth = true) => {
      const slide = slides[Math.max(0, Math.min(index, slides.length - 1))];
      if (!slide) return;
      track.scrollTo({ left: track.scrollLeft + slide.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: smooth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
    };
    previous?.addEventListener('click', () => go(closestIndex() - 1));
    next?.addEventListener('click', () => go(closestIndex() + 1));
    let frame = 0;
    track.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }, { passive: true });
    track.addEventListener('keydown', event => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      go(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : closestIndex() + (event.key === 'ArrowRight' ? 1 : -1));
    });
    requestAnimationFrame(() => { go(positions.get(root.closest('#drawer-cart') || root) || 0, false); update(); });
    if (window.ResizeObserver) {
      const observer = new ResizeObserver(() => { go(positions.get(root.closest('#drawer-cart') || root) || 0, false); update(); });
      observer.observe(track);
      resizeObservers.set(root, observer);
    }
  };
  const mount = drawer => {
    const source = drawer.querySelector('[data-line-items] [data-le-xs-source]');
    const outlet = drawer.querySelector('[data-le-xs-outlet]');
    if (!source || !outlet || source.dataset.leXsMoved) return;
    source.dataset.leXsMoved = 'true';
    const oldRoot = outlet.querySelector('[data-le-xs-cart]');
    if (oldRoot) resizeObservers.get(oldRoot)?.disconnect();
    outlet.replaceChildren(...source.childNodes);
    const root = outlet.querySelector('[data-le-xs-cart]');
    outlet.hidden = !root;
    drawer.dataset.leHasCustomRecommendations = String(Boolean(root));
    if (root) bind(root);
    else positions.delete(drawer);
    document.dispatchEvent(new CustomEvent('le:pair:layout'));
  };
  const setup = () => {
    const drawer = document.querySelector('#drawer-cart');
    if (drawer) mount(drawer);
    document.querySelectorAll('[data-le-xs-cart]').forEach(bind);
    document.querySelectorAll('[data-line-items]').forEach(lineItems => {
      if (lineItems.dataset.leXsObserver) return;
      lineItems.dataset.leXsObserver = 'true';
      let previousRoots = [...lineItems.querySelectorAll('[data-le-xs-cart]')];
      new MutationObserver(() => {
        const host = lineItems.closest('#drawer-cart');
        if (host) { mount(host); return; }
        previousRoots.filter(root => !root.isConnected).forEach(root => resizeObservers.get(root)?.disconnect());
        previousRoots = [...lineItems.querySelectorAll('[data-le-xs-cart]')];
        previousRoots.forEach(bind);
      }).observe(lineItems, { childList: true, subtree: true });
    });
  };
  document.addEventListener('change', event => {
    const select = event.target.closest?.('[data-le-xs-select]');
    if (!select) return;
    const row = select.closest('[data-le-xs-upgrade]') || select.closest('[data-le-xs-row]');
    const option = select.selectedOptions[0];
    if (!row || !option) return;
    row.dataset.variantId = option.value;
    row.dataset.price = option.dataset.price;
    const label = row.querySelector('.le-xs-price');
    if (label) label.textContent = option.dataset.priceLabel;
    row.querySelectorAll('a').forEach(link => { link.href = `${row.dataset.productUrl}?variant=${option.value}`; });
    const image = row.querySelector('.le-xs-image img');
    if (image && option.dataset.image) { image.src = option.dataset.image; image.removeAttribute('srcset'); }
    const swap = row.querySelector('[data-le-xs-swap]');
    if (swap && option.dataset.swapLabel) swap.textContent = option.dataset.swapLabel;
  });
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('le:cart:rendered', setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
})();
  } catch (error) {
    modules.delete("le-tessera-cart-carousel");
    console.error('LoveEcru snippet initialization failed:', "le-tessera-cart-carousel", error);
  }
})();

// Source: snippets/le-cart-enhancements.liquid
(() => {
  const modules = window.leSnippetRuntimeModules || (window.leSnippetRuntimeModules = new Set());
  if (modules.has("le-cart-enhancements")) return;
  modules.add("le-cart-enhancements");
  try {
(() => {
  const initialize = () => {
    const drawer = document.querySelector('#drawer-cart.le-cart');
    if (!drawer || drawer.dataset.leInitialized) return;
    drawer.dataset.leInitialized = 'true';
    const section = drawer.closest('[data-section-type="cart-drawer"]');
    const loader = drawer.querySelector('[data-cart-loading]');
    const status = drawer.querySelector('[data-le-cart-status]');
    const checkout = drawer.querySelector('[name="checkout"]');
    const retry = drawer.querySelector('[data-le-cart-retry]');
    const discover = drawer.querySelector('[data-le-discover]');
    const copy = drawer.dataset;
    const setAttribute = (element, name, value) => {
      const next = String(value);
      if (element && element.getAttribute(name) !== next) element.setAttribute(name, next);
    };
    const setText = (element, value) => {
      const next = String(value ?? '');
      if (element && element.textContent !== next) element.textContent = next;
    };
    let queued = false;
    let lastBusy = false;
    let lastFailed = false;
    let focusTarget = null;
    let pairAnnouncement = '';
    const visibleControl = element => element && !element.disabled && !element.closest('[hidden],[aria-hidden="true"]') && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden';
    if (window.theme?.strings) window.theme.strings.cartUpdateError = copy.leError;

    const restoreFocus = () => {
      if (!focusTarget || loader.classList.contains('cart--loading') || window.leTesseraPairBusy) return;
      if (focusTarget.pair && !focusTarget.confirmed) return;
      if (!drawer.matches('.drawer--visible, .is-open')) { focusTarget = null; return; }
      if (document.activeElement !== document.body && document.activeElement !== document.documentElement) {
        if (!drawer.contains(document.activeElement) || (focusTarget.pair && document.activeElement !== focusTarget.node)) focusTarget = null;
        if (!focusTarget?.pair || visibleControl(document.activeElement)) return;
      }
      if (focusTarget.pair) {
        const candidates = [...drawer.querySelectorAll('[data-le-xs-cart] [data-le-xs-add], [data-le-xs-cart] [data-le-xs-swap]')].filter(visibleControl);
        const target = candidates[Math.min(focusTarget.index, candidates.length - 1)] || (visibleControl(checkout) && checkout) || drawer.querySelector('.drawer__close');
        target?.focus({ preventScroll: true });
        target?.closest('[data-le-xs-row]')?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
        focusTarget = null;
        return;
      }
      const empty = drawer.dataset.leEmpty === 'true';
      const rows = empty ? [] : [...drawer.querySelectorAll('[data-cart-item]')];
      const row = rows.find(item => item.querySelector('[data-update-cart]')?.getAttribute('data-update-cart') === focusTarget.key);
      const fallback = rows[Math.min(focusTarget.index, rows.length - 1)];
      const target = row?.querySelector(focusTarget.selector) || fallback?.querySelector('[data-quantity-input]') || (empty && drawer.querySelector('.cart__circle__wrapper')) || drawer.querySelector('.drawer__close');
      target?.focus({ preventScroll: true });
      focusTarget = null;
    };

    const refresh = () => {
      queued = false;
      observer.disconnect();
      const busy = loader.classList.contains('cart--loading') || Boolean(window.leTesseraPairBusy);
      const failed = drawer.dataset.leCartError === 'true' || section.dataset.leCartError === 'true';
      const empty = !drawer.querySelector('[data-cart-empty]').classList.contains('cart--hidden');
      const open = drawer.matches('.drawer--visible, .is-open');
      setAttribute(loader, 'aria-busy', busy);
      setAttribute(drawer, 'data-le-empty', empty);
      if (!busy && !failed) {
        const currentCount = drawer.querySelector('[data-le-cart-count]');
        const quantities = [...drawer.querySelectorAll('[data-line-items] [data-cart-item] input[name="updates[]"]')].map(input => Number(input.value));
        if (empty) setText(currentCount, 0);
        else if (quantities.length && quantities.every(quantity => Number.isInteger(quantity) && quantity >= 0)) {
          setText(currentCount, quantities.reduce((total, quantity) => total + quantity, 0));
        }
      }
      drawer.querySelectorAll('[data-decrease-quantity], [data-increase-quantity], [data-quantity-input]').forEach(control => {
        if (busy && !control.disabled) {
          control.disabled = true;
          control.dataset.leQuantityDisabled = 'true';
        } else if (!busy && control.dataset.leQuantityDisabled) {
          control.disabled = false;
          delete control.dataset.leQuantityDisabled;
        }
      });
      drawer.querySelectorAll('.rebuy-button').forEach(control => {
        if (busy && !control.disabled) {
          control.disabled = true;
          control.dataset.leRebuyDisabled = 'true';
        } else if (!busy && control.dataset.leRebuyDisabled) {
          control.disabled = false;
          delete control.dataset.leRebuyDisabled;
        }
      });
      drawer.querySelectorAll('[data-remove-key]').forEach(control => {
        if (busy && control.getAttribute('aria-disabled') !== 'true') {
          control.setAttribute('aria-disabled', 'true');
          control.dataset.leRemoveDisabled = 'true';
        } else if (!busy && control.dataset.leRemoveDisabled) {
          control.removeAttribute('aria-disabled');
          delete control.dataset.leRemoveDisabled;
        }
      });
      if (busy && !checkout.disabled) {
        checkout.disabled = true;
        checkout.dataset.leDisabled = 'true';
      } else if (!busy && !failed && checkout.dataset.leDisabled) {
        checkout.disabled = false;
        delete checkout.dataset.leDisabled;
      }
      if (failed && !checkout.disabled) {
        checkout.disabled = true;
        checkout.dataset.leDisabled = 'true';
      }
      if (busy !== lastBusy || failed !== lastFailed) {
        if (busy && !lastBusy) pairAnnouncement = '';
        setText(status, busy ? copy.leLoading : failed ? copy.leError : pairAnnouncement || copy.leUpdated);
        lastBusy = busy;
        lastFailed = failed;
      }

      const items = drawer.querySelector('[data-line-items] > .cart__items');
      if (items) {
        const order = { product: 0, gift: 1, addon: 2 };
        const original = [...items.children];
        const sorted = [...original].sort((a, b) => (order[a.dataset.leItemKind] ?? 0) - (order[b.dataset.leItemKind] ?? 0));
        if (sorted.some((item, i) => item !== original[i])) sorted.forEach(item => items.append(item));
      }

      drawer.querySelectorAll('.bogos-progress-bar-container').forEach(rewards => {
        if (!rewards.querySelector('.le-rewards-heading')) {
          const heading = document.createElement('p');
          heading.className = 'le-rewards-heading';
          heading.textContent = copy.leRewardsLabel;
          rewards.prepend(heading);
        }
        const goals = [...rewards.querySelectorAll('.bogos-progress-goal-item')].filter(goal => {
          const hidden = goal.hidden || goal.classList.contains('sca-d-none') || goal.style.display === 'none';
          goal.toggleAttribute('data-le-reward-hidden', hidden);
          if (hidden) {
            delete goal.dataset.leState;
            goal.querySelector('.le-reward-state')?.remove();
          }
          return !hidden;
        });
        setAttribute(rewards, 'data-le-reward-count', goals.length);
        let nextFound = false;
        goals.forEach(goal => {
          if (rewards.dataset.boosterId === '7527' && goal.dataset.goalId === '1') setAttribute(goal, 'data-le-gift-exposure', 'cart');
          else if (goal.dataset.leGiftExposure === 'cart') delete goal.dataset.leGiftExposure;
          const appState = goal.querySelector('[data-goal-state]');
          if (!rewards.hasAttribute('data-bogos-reached') && !appState?.textContent.trim() && !goal.classList.contains('bogos-active')) {
            delete goal.dataset.leState;
            goal.querySelector('.le-reward-state')?.remove();
            appState?.removeAttribute('aria-hidden');
            return;
          }
          const complete = goal.classList.contains('bogos-active');
          const next = !complete && !nextFound;
          if (next) nextFound = true;
          setAttribute(goal, 'data-le-state', complete ? 'complete' : next ? 'next' : 'upcoming');
          let label = goal.querySelector('.le-reward-state');
          if (!label) {
            label = document.createElement('span');
            label.className = 'le-reward-state';
            goal.querySelector('.bogos-progress-goal-info-item')?.append(label);
          }
          setAttribute(goal.querySelector('[data-goal-state]'), 'aria-hidden', 'true');
          setText(label, complete ? copy.leUnlocked : next ? copy.leNext : copy.leUpcoming);
        });
      });

      drawer.querySelectorAll('.rebuy-product-actions .rebuy-button').forEach(button => {
        const label = button.querySelector('span');
        if (!label || button.disabled) return;
        const text = label.textContent.trim().toLowerCase();
        const product = button.closest('.rebuy-product-block')?.querySelector('.rebuy-product-title')?.textContent.trim() || '';
        let replacement;
        if (/^(size|color|colour|quantity|options|style|choose options)$/.test(text)) replacement = copy.leChoose;
        else if (/^(add|add to cart|add to bag)$/.test(text)) replacement = copy.leAdd;
        if (replacement) {
          setText(label, replacement);
          setAttribute(button, 'aria-label', `${replacement}: ${product}`);
        }
      });

      if (open) drawer.querySelectorAll('.rebuy-widget').forEach(widget => {
        const cards = [...widget.querySelectorAll('.rebuy-product-block')];
        const height = Math.ceil(Math.max(0, ...cards.map(card => card.scrollHeight)));
        if (height > 0 && widget.style.getPropertyValue('--le-rebuy-height') !== `${height}px`) widget.style.setProperty('--le-rebuy-height', `${height}px`);
      });
      const recommendations = drawer.querySelector('#rebuy-widget-180683');
      const tesseraPairs = drawer.querySelector('[data-le-xs-cart]');
      const pairControls = tesseraPairs ? [...tesseraPairs.querySelectorAll('[data-le-xs-add], [data-le-xs-swap]')].filter(visibleControl) : [];
      const hideDiscover = empty || (!pairControls.length && !recommendations?.getClientRects().length);
      if (discover.hidden !== hideDiscover) discover.hidden = hideDiscover;
      const shippingSuccess = drawer.querySelector('.cart__message-success');
      setText(shippingSuccess, copy.leShippingSuccess);
      const discount = drawer.querySelector('.lit__discount_input');
      setAttribute(discount, 'aria-label', copy.leDiscountLabel);
      drawer.querySelectorAll('[data-accordion-trigger]').forEach(button => {
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        if (open && panel) setAttribute(button, 'aria-expanded', getComputedStyle(panel).display !== 'none');
        button.removeAttribute('aria-haspopup');
      });
      const discountError = drawer.querySelector('.lit__invalid_discount_message');
      setAttribute(discountError, 'role', 'alert');
      restoreFocus();
      observer.observe(section, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'data-le-cart-error', 'aria-hidden', 'disabled'] });
    };
    const schedule = () => {
      if (!queued) {
        queued = true;
        requestAnimationFrame(refresh);
      }
    };
    const observer = new MutationObserver(schedule);
    drawer.addEventListener('keydown', event => {
      if (event.key !== 'Tab' || !drawer.matches('.drawer--visible, .is-open')) return;
      const controls = [...drawer.querySelectorAll('a[href],button:not(:disabled),input:not([type="hidden"]):not(:disabled),select:not(:disabled),textarea:not(:disabled),[tabindex="0"]')].filter(element => element.tabIndex >= 0 && !element.closest('[hidden],[aria-hidden="true"]') && element.getClientRects().length && getComputedStyle(element).visibility === 'visible');
      const first = controls[0];
      const last = controls[controls.length - 1];
      event.stopPropagation();
      if (event.shiftKey && (event.target === first || !controls.includes(event.target))) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && (event.target === last || !controls.includes(event.target))) {
        event.preventDefault();
        first?.focus();
      }
    }, true);
    drawer.addEventListener('click', event => {
      const pairControl = event.target.closest('[data-le-xs-cart] [data-le-xs-add], [data-le-xs-cart] [data-le-xs-swap]');
      if (pairControl) {
        const controls = [...drawer.querySelectorAll('[data-le-xs-cart] [data-le-xs-add], [data-le-xs-cart] [data-le-xs-swap]')];
        focusTarget = { pair: true, confirmed: false, node: pairControl, index: Math.max(0, controls.indexOf(pairControl)) };
      }
      const control = event.target.closest('[data-decrease-quantity], [data-increase-quantity], [data-remove-key]');
      if (control && (loader.classList.contains('cart--loading') || window.leTesseraPairBusy)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (control) {
        const row = control.closest('[data-cart-item]');
        focusTarget = { key: row.querySelector('[data-update-cart]')?.getAttribute('data-update-cart'), index: [...drawer.querySelectorAll('[data-cart-item]')].indexOf(row), selector: control.hasAttribute('data-increase-quantity') ? '[data-increase-quantity]' : control.hasAttribute('data-decrease-quantity') ? '[data-decrease-quantity]' : '[data-remove-key]' };
      }
    }, true);
    drawer.addEventListener('change', event => {
      if (!event.target.matches('[data-quantity-input]')) return;
      if (focusTarget?.key === event.target.getAttribute('data-update-cart')) return;
      const row = event.target.closest('[data-cart-item]');
      focusTarget = { key: event.target.getAttribute('data-update-cart'), index: [...drawer.querySelectorAll('[data-cart-item]')].indexOf(row), selector: '[data-quantity-input]' };
    }, true);
    retry.addEventListener('click', event => { event.preventDefault(); window.location.reload(); });
    discover.addEventListener('click', event => {
      event.preventDefault();
      const pairTarget = drawer.querySelector('[data-le-xs-cart]');
      const target = pairTarget?.getClientRects().length ? pairTarget : drawer.querySelector('#le-cart-recommendations');
      if (!target) return;
      target.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      const control = [...target.querySelectorAll('[data-le-xs-add], [data-le-xs-swap], .rebuy-product-block.is-selected .rebuy-button')].find(visibleControl);
      control?.focus({ preventScroll: true });
      control?.closest('[data-le-xs-slide]')?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
    });
    document.addEventListener('le:pair:state', schedule);
    document.addEventListener('le:pair:layout', schedule);
    document.addEventListener('le:pair:complete', event => {
      pairAnnouncement = event.detail?.message || copy.leUpdated;
      if (focusTarget?.pair) focusTarget.confirmed = true;
      if (!window.leTesseraPairBusy && !loader.classList.contains('cart--loading')) setText(status, pairAnnouncement);
      schedule();
    });
    document.addEventListener('theme:cart:change', event => {
      if (event.detail?.cart) setText(drawer.querySelector('[data-le-cart-count]'), event.detail.cart.item_count);
      schedule();
    });
    drawer.addEventListener('theme:drawer:open', schedule);
    drawer.addEventListener('theme:drawer:close', () => { focusTarget = null; });
    window.addEventListener('resize', schedule, { passive: true });
    drawer.addEventListener('load', schedule, true);
    refresh();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();


(() => {
  if (window.leCartRewardsSyncReady) return;
  window.leCartRewardsSyncReady = true;
  let refreshTimer = null;
  let retries = 0;
  let lastSignature = '';
  let duplicateFrame = null;
  const signature = cart => JSON.stringify([cart.currency, cart.total_price, cart.items.map(item => [item.key, item.quantity, item.final_line_price])]);
  const removeDuplicateMessages = () => {
    duplicateFrame = null;
    document.querySelectorAll('#drawer-cart .bogos-progress-bar-container, [data-section-type="cart"] .bogos-progress-bar-container').forEach(rewards => {
      const countdown = rewards.querySelector('.bogos-progress-count-down-message');
      const success = rewards.querySelector('.bogos-progress-success-label-container');
      if (!success) return;
      const normalize = element => element?.textContent.replace(/\s+/g, ' ').trim() || '';
      const duplicate = countdown && countdown.style.display !== 'none' && !countdown.classList.contains('sca-d-none') && normalize(countdown) && normalize(countdown) === normalize(success);
      success.toggleAttribute('data-le-duplicate-message', Boolean(duplicate));
    });
  };
  const scheduleMessages = () => {
    if (!duplicateFrame) duplicateFrame = requestAnimationFrame(removeDuplicateMessages);
  };
  const refreshRewards = () => {
    refreshTimer = null;
    const events = window.FGSECOMAPP?.CUSTOM_EVENTS;
    if (!events?.BOGOS_CART_CHANGE || !events?.BOGOS_BOOSTER_INIT) {
      if (++retries <= 10) refreshTimer = setTimeout(refreshRewards, 600);
      return;
    }
    document.dispatchEvent(new CustomEvent(events.BOGOS_CART_CHANGE));
    document.dispatchEvent(new CustomEvent(events.BOGOS_BOOSTER_INIT));
    scheduleMessages();
  };
  const scheduleRewards = cart => {
    if (cart && Array.isArray(cart.items)) {
      const next = signature(cart);
      if (next === lastSignature) return;
      lastSignature = next;
    }
    retries = 0;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshRewards, 650);
  };
  const observeCarts = () => {
    document.querySelectorAll('[data-section-type="cart"], [data-section-type="cart-drawer"]').forEach(section => {
      if (section.dataset.leRewardsObserved) return;
      section.dataset.leRewardsObserved = 'true';
      new MutationObserver(scheduleMessages).observe(section, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
      section.querySelector('#drawer-cart')?.addEventListener('theme:drawer:open', () => scheduleRewards());
    });
    scheduleMessages();
    scheduleRewards();
  };
  document.addEventListener('theme:cart:change', event => scheduleRewards(event.detail?.cart));
  document.addEventListener('le:pair:complete', event => scheduleRewards(event.detail?.cart));
  document.addEventListener('bogos:progress-render', scheduleMessages);
  document.addEventListener('shopify:section:load', observeCarts);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeCarts, { once: true });
  else observeCarts();
})();

(() => {
  const rootSelector = '#freegifts-main-popup-container';
  let root = null;
  let queued = false;
  const observedAttributes = ['class', 'style', 'min', 'max', 'value', 'data-quantity'];
  const setMarker = (element, attribute, enabled, value = 'true') => {
    if (enabled && element.getAttribute(attribute) !== value) element.setAttribute(attribute, value);
    else if (!enabled && element.hasAttribute(attribute)) element.removeAttribute(attribute);
  };
  const refresh = () => {
    queued = false;
    if (!root?.isConnected) return;
    observer.disconnect();
    const modal = root.querySelector('.bogos-gift-slider-modal');
    const offers = modal?.querySelector('.bogos-slider-offers-container');
    const recognized = Boolean(offers);
    if (root.classList.contains('le-gift-picker') !== recognized) root.classList.toggle('le-gift-picker', recognized);
    if (offers) {
      setMarker(offers, 'data-scroll-lock-scrollable', true, '');
      offers.querySelectorAll('.bogos-gift-select-variant-options, .bogos-gift-item-quantity-options').forEach(options => {
        setMarker(options, 'data-scroll-lock-scrollable', true, '');
      });
      offers.querySelectorAll('.glider-contain').forEach(list => {
        const track = list.querySelector(':scope > .bogos-offer-gift-items-container > .glider-track');
        const cards = track ? [...track.children].filter(card => card.matches('.bogos-offer-gift-item')) : [];
        const ready = cards.length > 0 && cards.length === track.children.length && cards.every(card => card.querySelector('.bogos-gift-item-add-btn'));
        setMarker(list, 'data-le-gift-list', ready);
        cards.forEach(card => {
          const input = card.querySelector('.bogos-gift-item-quantity-input');
          const options = card.querySelectorAll('.bogos-gift-item-quantity-option');
          const fixed = ready && input && Number(input.getAttribute('min')) === 1 && Number(input.getAttribute('max')) === 1 && Number(input.value) === 1 && options.length === 1 && options[0].getAttribute('data-quantity') === '1';
          setMarker(card, 'data-le-fixed-quantity', Boolean(fixed));
        });
      });
    }
    observer.observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: observedAttributes });
  };
  const schedule = () => {
    if (queued || !root?.isConnected) return;
    queued = true;
    requestAnimationFrame(refresh);
  };
  const observer = new MutationObserver(schedule);
  const attach = next => {
    if (!next || next === root) return;
    observer.disconnect();
    root?.removeEventListener('input', schedule, true);
    root?.removeEventListener('change', schedule, true);
    root = next;
    root.addEventListener('input', schedule, true);
    root.addEventListener('change', schedule, true);
    refresh();
  };
  const start = () => {
    attach(document.querySelector(rootSelector));
    const discovery = new MutationObserver(records => {
      if (root?.isConnected) return;
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType !== 1) continue;
          const next = node.matches(rootSelector) ? node : node.querySelector(rootSelector);
          if (next) { attach(next); return; }
        }
      }
    });
    discovery.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', schedule, { passive: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch (error) {
    modules.delete("le-cart-enhancements");
    console.error('LoveEcru snippet initialization failed:', "le-cart-enhancements", error);
  }
})();

// Source: snippets/le-cart-recommendations-load.liquid
(() => {
  const modules = window.leSnippetRuntimeModules || (window.leSnippetRuntimeModules = new Set());
  if (modules.has("le-cart-recommendations-load")) return;
  modules.add("le-cart-recommendations-load");
  try {
(() => {
  const setup = () => {
    document.querySelectorAll('[data-drawer="drawer-cart"]').forEach(drawer => {
      if (drawer.dataset.leRecommendationsReady || !drawer.querySelector('[data-le-rebuy-id]')) return;
      drawer.dataset.leRecommendationsReady = 'true';
      let active = false;
      const activate = () => {
        if (active) return;
        active = true;
        drawer.querySelectorAll('[data-le-rebuy-id]').forEach(element => {
          element.setAttribute('data-rebuy-id', element.dataset.leRebuyId);
          element.removeAttribute('data-le-rebuy-id');
        });
        observer.disconnect();
        document.removeEventListener('pointerdown', onIntent, true);
        drawer.removeEventListener('theme:drawer:open', activate);
        let retryTimer = null;
        let attempts = 0;
        let initialized = false;
        const initializeRebuy = () => {
          if (initialized || !drawer.isConnected) return;
          clearTimeout(retryTimer);
          if (typeof window.Rebuy?.init === 'function') {
            window.Rebuy.init();
            initialized = true;
            document.removeEventListener('rebuy.loaded', initializeRebuy);
            window.removeEventListener('load', initializeRebuy);
          } else if (++attempts <= 20) {
            retryTimer = setTimeout(initializeRebuy, 500);
          }
        };
        document.addEventListener('rebuy.loaded', initializeRebuy);
        window.addEventListener('load', initializeRebuy, { once: true });
        initializeRebuy();
      };
      const onIntent = event => {
        if (event.target.closest?.('[data-drawer-toggle="drawer-cart"]')) activate();
      };
      const observer = new MutationObserver(() => {
        if (drawer.matches('.drawer--visible, .is-open')) activate();
      });
      observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      drawer.addEventListener('theme:drawer:open', activate);
      document.addEventListener('pointerdown', onIntent, true);
      if (drawer.matches('.drawer--visible, .is-open')) activate();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
  } catch (error) {
    modules.delete("le-cart-recommendations-load");
    console.error('LoveEcru snippet initialization failed:', "le-cart-recommendations-load", error);
  }
})();

// Source: snippets/le-product-recommendations-load.liquid
(() => {
  const modules = window.leSnippetRuntimeModules || (window.leSnippetRuntimeModules = new Set());
  if (modules.has("le-product-recommendations-load")) return;
  modules.add("le-product-recommendations-load");
  try {
(() => {
  const selector = '[data-le-rebuy-id="135001"]';
  const observed = new WeakSet();
  const pending = new Set();
  let listening = false;
  let frame = 0;
  const stopListening = () => {
    if (pending.size || !listening) return;
    window.removeEventListener('scroll', scheduleCheck);
    window.removeEventListener('resize', scheduleCheck);
    if (frame) window.cancelAnimationFrame(frame);
    frame = 0;
    listening = false;
  };
  const activate = element => {
    pending.delete(element);
    observer?.unobserve(element);
    stopListening();
    if (!element.isConnected || !element.matches(selector)) return;
    element.setAttribute('data-rebuy-id', element.dataset.leRebuyId);
    element.removeAttribute('data-le-rebuy-id');
    const initialize = () => {
      if (!element.isConnected || typeof window.Rebuy?.init !== 'function') return;
      window.Rebuy.init();
      document.removeEventListener('rebuy.loaded', initialize);
    };
    if (typeof window.Rebuy?.init === 'function') initialize();
    else document.addEventListener('rebuy.loaded', initialize);
  };
  const observer = typeof IntersectionObserver === 'function'
    ? new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        activate(entry.target);
      });
    }, { rootMargin: '200px 0px', threshold: 0 })
    : null;
  const checkPosition = () => {
    frame = 0;
    pending.forEach(element => {
      // A page jump can skip a zero-height app marker without intersecting it.
      if (!element.isConnected || element.getBoundingClientRect().top <= window.innerHeight + 200) {
        activate(element);
      }
    });
  };
  const scheduleCheck = () => {
    if (!frame) frame = window.requestAnimationFrame(checkPosition);
  };
  const setup = (root = document) => {
    root.querySelectorAll(selector).forEach(element => {
      if (observed.has(element)) return;
      observed.add(element);
      if (observer) {
        pending.add(element);
        observer.observe(element);
      }
      else activate(element);
    });
    if (pending.size && !listening) {
      window.addEventListener('scroll', scheduleCheck, { passive: true });
      window.addEventListener('resize', scheduleCheck, { passive: true });
      listening = true;
    }
    checkPosition();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setup(), { once: true });
  } else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
  } catch (error) {
    modules.delete("le-product-recommendations-load");
    console.error('LoveEcru snippet initialization failed:', "le-product-recommendations-load", error);
  }
})();

// Source: snippets/le-footer-style.liquid
(() => {
  const modules = window.leSnippetRuntimeModules || (window.leSnippetRuntimeModules = new Set());
  if (modules.has("le-footer-style")) return;
  modules.add("le-footer-style");
  try {
(() => {
  const initializeFooter = (root = document) => {
    root.querySelectorAll('[data-le-footer]').forEach((footer) => {
      if (footer.dataset.leFooterReady) return;
      footer.dataset.leFooterReady = 'true';
      const media = window.matchMedia('(min-width: 750px)');
      const disclosures = footer.querySelectorAll('[data-le-footer-accordion]');
      const adapt = () => disclosures.forEach((details) => {
        details.open = media.matches;
        const summary = details.querySelector('summary');
        if (media.matches) summary.setAttribute('tabindex', '-1');
        else summary.removeAttribute('tabindex');
      });
      adapt();
      media.addEventListener('change', adapt);
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(footer)) media.removeEventListener('change', adapt);
      });
    });
  };
  initializeFooter();
  document.addEventListener('shopify:section:load', (event) => initializeFooter(event.target));
})();
  } catch (error) {
    modules.delete("le-footer-style");
    console.error('LoveEcru snippet initialization failed:', "le-footer-style", error);
  }
})();

// Source: snippets/le-gift-measurement.liquid
(() => {
  const modules = window.leSnippetRuntimeModules || (window.leSnippetRuntimeModules = new Set());
  if (modules.has("le-gift-measurement")) return;
  modules.add("le-gift-measurement");
  try {
(() => {
  const configNode = document.getElementById('le-gift-measurement-config');
  if (!configNode || window.leGiftMeasurementReady || window.Shopify?.designMode || new URLSearchParams(location.search).has('preview_theme_id')) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  window.leGiftMeasurementReady = true;
  const storageKey = 'le_gift_' + config.campaign + '_v1';
  const ttl = 30 * 60 * 1000;
  const observed = new WeakSet();
  const visible = new Set();
  const timers = new Map();
  const validSurfaces = new Set(['announcement', 'homepage', 'details', 'pdp', 'cart']);
  let state = null;
  let activeConsent = false;
  let current = null;
  let readTimer;
  let readInFlight = false;
  let readAgain = false;
  let cartRevision = 0;
  let lastCheckoutAt = 0;

  const allowed = () => {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; } catch (_) { return false; }
  };
  const save = () => {
    if (!state || !allowed()) return;
    state.expires = Date.now() + ttl;
    try { sessionStorage.setItem(storageKey, JSON.stringify(state)); } catch (_) {}
  };
  const reset = () => {
    state = null;
    current = null;
    activeConsent = false;
    lastCheckoutAt = 0;
    timers.forEach(timer => clearTimeout(timer));
    timers.clear();
    try { sessionStorage.removeItem(storageKey); } catch (_) {}
  };
  const session = () => {
    if (!allowed()) { reset(); return false; }
    if (state && state.expires > Date.now()) return true;
    state = null;
    try {
      const stored = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      if (stored?.expires > Date.now() && typeof stored.id === 'string' && Array.isArray(stored.surfaces)) state = stored;
    } catch (_) {}
    if (!state) {
      const id = window.crypto?.randomUUID ? window.crypto.randomUUID() : String(Date.now()) + '-' + Math.random().toString(36).slice(2);
      state = { id, expires: Date.now() + ttl, sequence: 0, surfaces: [], exposed: false, last: null };
    }
    return true;
  };
  const threshold = currency => {
    if (currency === 'USD' || currency === 'EUR') return 13500;
    const context = window.Shopify?.currency;
    const rate = Number(context?.rate);
    if (config.baseCurrency !== 'USD' || context?.active !== currency || !Number.isFinite(rate) || rate <= 0) return null;
    return Math.round(Number((135 * rate).toFixed(2)) * 100);
  };
  const giftItem = item => {
    const properties = item.properties || {};
    const clone = String(item.handle || '').includes('-sca_clone_freegift');
    const marker = ['_bogos_trigger_id', '_bogos_trigger', '_bogos_trigger_type'].some(key => properties[key] != null && properties[key] !== '');
    return clone || (Number(item.final_line_price) === 0 && (marker || /\(100% off\)/i.test(item.product_title || item.title || '')));
  };
  const snapshot = cart => {
    if (!cart || !Array.isArray(cart.items) || !/^[A-Z]{3}$/.test(cart.currency || '')) return null;
    let subtotal = 0;
    let complimentary = 0;
    let paidMirror = 0;
    for (const item of cart.items) {
      const quantity = Number(item.quantity);
      const original = Number(item.original_line_price);
      if (!Number.isInteger(quantity) || quantity < 0 || item.original_line_price == null || item.final_line_price == null || !Number.isFinite(original) || original < 0 || !Number.isFinite(Number(item.final_line_price))) return null;
      const variant = String(item.variant_id || item.id || '');
      const gift = giftItem(item);
      const mirrorGift = gift && (variant === config.originalVariantId || (config.giftVariantId !== '0' && variant === config.giftVariantId));
      if (mirrorGift && Number(item.final_line_price) === 0) complimentary += quantity;
      if (gift || item.gift_card === true || String(item.product_id) === '8754489885008') continue;
      subtotal += original;
      if (variant === config.originalVariantId) paidMirror += quantity;
    }
    const limit = threshold(cart.currency);
    return { currency: cart.currency, subtotal: Math.round(subtotal), threshold: limit, eligible: limit == null ? null : subtotal >= limit, complimentary, paidMirror };
  };
  const attributes = data => ({
    currency: data?.currency || null,
    qualifying_subtotal_minor: data?.subtotal ?? null,
    threshold_minor: data?.threshold ?? null,
    estimated_eligible: data?.eligible ?? null,
    complimentary_mirror_quantity: data?.complimentary ?? null,
    paid_mirror_quantity: data?.paidMirror ?? null,
    eligibility_basis: 'pre_discount_merchandise_estimate'
  });
  const emit = (name, detail = {}) => {
    if (!session()) return false;
    const data = {
      campaign_id: config.campaign,
      bogos_offer_id: config.offerId,
      original_variant_id: config.originalVariantId,
      campaign_session_id: state.id,
      event_id: state.id + '.' + (++state.sequence),
      page_type: config.pageType,
      ...detail
    };
    let sent = false;
    if (typeof window.Shopify?.analytics?.publish === 'function') {
      try {
        const result = window.Shopify.analytics.publish('loveecru:' + name, data);
        if (result?.catch) result.catch(() => {});
        sent = result !== false;
      } catch (_) {}
    } else {
      try {
        if (allowed() && window.Shopify?.customerPrivacy?.marketingAllowed() === true && Array.isArray(window.dataLayer)) {
          window.dataLayer.push({ event: 'loveecru_' + name, ...data });
          sent = true;
        }
      } catch (_) {}
    }
    save();
    return sent;
  };
  const updateCart = (cart, source) => {
    if (!allowed() || !session()) return;
    const next = snapshot(cart);
    if (!next) return;
    cartRevision++;
    current = next;
    const previous = state.last;
    const comparable = previous && previous.currency === next.currency;
    if (state.exposed) {
      if (comparable && next.subtotal > previous.subtotal) {
        emit('gift_cart_increased', { ...attributes(next), previous_subtotal_minor: previous.subtotal, increase_minor: next.subtotal - previous.subtotal, source, observation: 'cart_value_increase_after_offer_exposure' });
      }
      if (!comparable || previous.eligible !== next.eligible) {
        emit('gift_eligibility_observed', { ...attributes(next), previous_estimated_eligible: comparable ? previous.eligible : null, source });
      }
      if (!comparable || previous.complimentary !== next.complimentary) {
        emit('gift_cart_observed', { ...attributes(next), previous_complimentary_mirror_quantity: comparable ? previous.complimentary : null, change: !comparable ? 'initial_observation' : next.complimentary > previous.complimentary ? 'added' : 'removed', redemption_stage: 'cart_only', source });
      }
    }
    state.last = next;
    save();
    visible.forEach(arm);
  };
  const readCart = () => {
    if (!allowed()) return;
    if (readInFlight) { readAgain = true; return; }
    readInFlight = true;
    const revision = cartRevision;
    const root = window.Shopify?.routes?.root || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(response => response.ok ? response.json() : null)
      .then(cart => { if (revision === cartRevision) updateCart(cart, 'cart_read'); })
      .catch(() => {})
      .finally(() => {
        readInFlight = false;
        if (readAgain) { readAgain = false; scheduleRead(); }
      });
  };
  const scheduleRead = () => {
    if (!allowed()) return;
    clearTimeout(readTimer);
    readTimer = setTimeout(readCart, 250);
  };
  const visibleNow = element => {
    if (!element.isConnected || document.hidden || element.closest('[hidden], [aria-hidden="true"]')) return false;
    if (typeof element.checkVisibility === 'function' && !element.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true })) return false;
    const style = getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    const rect = element.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return false;
    const area = Math.max(0, Math.min(rect.right, innerWidth) - Math.max(rect.left, 0)) * Math.max(0, Math.min(rect.bottom, innerHeight) - Math.max(rect.top, 0));
    return area / (rect.width * rect.height) >= 0.5;
  };
  const surfaceOf = element => element.dataset.leGiftExposure || 'cart';
  const expose = element => {
    timers.delete(element);
    if (!allowed() || !visible.has(element) || !visibleNow(element) || !session()) return;
    const surface = surfaceOf(element);
    if (!validSurfaces.has(surface) || state.surfaces.includes(surface)) return;
    if (!current) return;
    if (emit('gift_offer_viewed', { ...attributes(current), surface, visibility_rule: 'half_visible_one_second' })) {
      const first = !state.exposed;
      state.exposed = true;
      state.surfaces.push(surface);
      state.last = current;
      save();
      if (first) {
        emit('gift_eligibility_observed', { ...attributes(current), previous_estimated_eligible: null, source: 'first_visible_exposure' });
        emit('gift_cart_observed', { ...attributes(current), previous_complimentary_mirror_quantity: null, change: 'initial_observation', redemption_stage: 'cart_only', source: 'first_visible_exposure' });
      }
    }
  };
  const arm = element => {
    if (!allowed() || timers.has(element) || state?.surfaces.includes(surfaceOf(element)) || !visibleNow(element)) return;
    timers.set(element, setTimeout(() => expose(element), 1000));
  };
  const observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting && entry.intersectionRatio >= 0.5) { visible.add(entry.target); arm(entry.target); }
      else { visible.delete(entry.target); clearTimeout(timers.get(entry.target)); timers.delete(entry.target); }
    });
  }, { threshold: [0, 0.5] }) : null;
  const exposureSelector = '[data-le-gift-exposure], .bogos-progress-goal-item';
  const scan = (container = document) => {
    if (!observer) return;
    const candidates = [...container.querySelectorAll(exposureSelector)];
    if (container.matches?.(exposureSelector)) candidates.unshift(container);
    candidates.forEach(element => {
      if (observed.has(element)) return;
      if (element.matches('.bogos-progress-goal-item') && !/concha|pocket mirror|bijou/i.test(element.textContent)) return;
      if (!validSurfaces.has(surfaceOf(element))) return;
      observed.add(element);
      observer.observe(element);
    });
  };
  const consentChanged = () => {
    // An API still loading is not a consent withdrawal. Keep the saved session
    // untouched until permission can be checked; all collection stays gated.
    if (typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed !== 'function') return;
    if (!allowed()) { reset(); return; }
    if (!activeConsent) {
      activeConsent = true;
      session();
      scheduleRead();
    }
    visible.forEach(arm);
  };
  document.addEventListener('visitorConsentCollected', consentChanged);
  document.addEventListener('theme:cart:change', event => {
    if (!allowed()) return;
    updateCart(event.detail?.cart, 'theme_cart_response');
    visible.forEach(arm);
  });
  document.addEventListener('fg-gifts:updated', scheduleRead);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) { timers.forEach(clearTimeout); timers.clear(); }
    else { consentChanged(); visible.forEach(arm); }
  });
  document.addEventListener('click', event => {
    if (event.isTrusted !== true) return;
    const target = event.target?.closest?.('[name="checkout"], a[href]');
    if (!target || !allowed() || !session() || !state.exposed || target.disabled || target.getAttribute('aria-disabled') === 'true' || !visibleNow(target)) return;
    if (target.tagName === 'A') {
      let url;
      try { url = new URL(target.href, location.href); } catch (_) { return; }
      if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?checkout(?:\/|$)/.test(url.pathname)) return;
    }
    const now = Date.now();
    if (now - lastCheckoutAt < 1500) return;
    lastCheckoutAt = now;
    emit('gift_checkout_clicked', { ...attributes(current), interaction: 'storefront_checkout_control_click', checkout_reached: false });
  }, true);
  let scanQueued = false;
  const scanRoots = new Set();
  const visibilityChecks = new Set();
  new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'childList') {
        record.addedNodes.forEach(node => { if (node.nodeType === 1) scanRoots.add(node); });
        const surface = record.target.closest?.(exposureSelector);
        if (surface) scanRoots.add(surface);
      } else if (record.target.matches(exposureSelector)) {
        scanRoots.add(record.target);
      }
      visible.forEach(element => {
        if (!element.isConnected || record.target.contains(element) || element.contains(record.target)) visibilityChecks.add(element);
      });
    });
    if (scanQueued || (!scanRoots.size && !visibilityChecks.size)) return;
    scanQueued = true;
    requestAnimationFrame(() => {
      scanQueued = false;
      scanRoots.forEach(root => { if (root.isConnected) scan(root); });
      scanRoots.clear();
      visibilityChecks.forEach(element => {
        if (element.isConnected) arm(element);
        else {
          visible.delete(element);
          clearTimeout(timers.get(element));
          timers.delete(element);
        }
      });
      visibilityChecks.clear();
    });
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'class', 'style', 'open', 'data-le-gift-exposure'] });
  scan();
  consentChanged();
  if (typeof window.Shopify?.loadFeatures === 'function' && !window.Shopify?.customerPrivacy) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) consentChanged(); });
  }
  let attempts = 0;
  const readiness = setInterval(() => {
    consentChanged();
    if (window.Shopify?.customerPrivacy || ++attempts >= 30) clearInterval(readiness);
  }, 1000);
})();
  } catch (error) {
    modules.delete("le-gift-measurement");
    console.error('LoveEcru snippet initialization failed:', "le-gift-measurement", error);
  }
})();

// Source: snippets/le-halloween-offer.liquid
(() => {
  const modules = window.leSnippetRuntimeModules || (window.leSnippetRuntimeModules = new Set());
  if (modules.has("le-halloween-offer")) return;
  modules.add("le-halloween-offer");
  try {
if (!customElements.get('le-halloween-offer')) {
    class LeHalloweenOffer extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.button = this.querySelector('[data-add]');
        this.status = this.querySelector('[data-status]');
        this.originalLabel = this.button.textContent;
        this.busy = false;
        if (!this.isActive()) {
          this.hidden = true;
          return;
        }
        this.button.disabled = false;
        this.button.addEventListener('click', () => this.completeSet());
      }

      isActive() {
        const start = Date.parse(this.dataset.start);
        const end = Date.parse(this.dataset.end);
        const now = Date.now();
        return Number.isFinite(start) && Number.isFinite(end) && now >= start && now < end;
      }

      async completeSet() {
        if (this.busy) return;
        if (!this.isActive()) {
          this.status.textContent = this.dataset.expired;
          this.button.disabled = true;
          return;
        }
        this.busy = true;
        this.button.disabled = true;
        this.setAttribute('aria-busy', 'true');
        this.button.textContent = this.dataset.adding;
        this.status.textContent = '';
        let submitted = false;
        try {
          const cartResponse = await fetch(this.dataset.cartJson, {
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' }
          });
          if (!cartResponse.ok) throw new Error('cart_read');
          const cart = await cartResponse.json();
          if (!Array.isArray(cart.items)) throw new Error('cart_shape');
          const shortId = 53412463640912;
          const tallId = 53412463608144;
          const quantityOf = (id) => cart.items.reduce((sum, item) =>
            sum + (Number(item.variant_id) === id ? Number(item.quantity) || 0 : 0), 0);
          const shortCount = quantityOf(shortId);
          const tallCount = quantityOf(tallId);
          const remaining = Math.max(0, 10 - shortCount - tallCount);
          if (remaining === 0) {
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          const style = this.querySelector('[data-style]').value;
          const shortAdd = style === 'short' ? remaining
            : style === 'tall' ? 0
              : Math.min(remaining, Math.max(0, 5 - shortCount));
          const items = [
            { id: shortId, quantity: shortAdd },
            { id: tallId, quantity: remaining - shortAdd }
          ].filter((item) => item.quantity > 0);
          if (!this.isActive()) throw new Error('expired');
          submitted = true;
          const addResponse = await fetch(this.dataset.addUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          const added = await addResponse.json();
          if (!addResponse.ok) {
            this.status.textContent = typeof added.description === 'string'
              ? added.description
              : this.dataset.uncertain;
            return;
          }
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.status.textContent = submitted ? this.dataset.uncertain
            : error.message === 'expired' ? this.dataset.expired
              : this.dataset.error;
        } finally {
          this.removeAttribute('aria-busy');
          this.button.textContent = this.originalLabel;
          if (!submitted && this.isActive()) {
            this.busy = false;
            this.button.disabled = false;
          }
        }
      }
    }
    customElements.define('le-halloween-offer', LeHalloweenOffer);
  }
  } catch (error) {
    modules.delete("le-halloween-offer");
    console.error('LoveEcru snippet initialization failed:', "le-halloween-offer", error);
  }
})();
